import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { env } from '@/config/env';

export const reactPlugin = new ReactPlugin();

const connectionString = env.VITE_APPINSIGHTS_CONNECTION_STRING?.trim();

// Telemetry is opt-in: the connection string is optional in env.ts and is not set
// in the pipeline, so deployed builds can ship without one. loadAppInsights() then
// throws "Please provide instrumentation key" synchronously during bootstrap, which
// takes the whole app down before it renders — so every entry point is guarded.
export const isAppInsightsEnabled = Boolean(connectionString);

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  },
});

let isLoaded = false;

export function initAppInsights(): void {
  if (!isAppInsightsEnabled || isLoaded) return;
  appInsights.loadAppInsights();
  appInsights.trackPageView();
  isLoaded = true;
}

// Safe in every environment: no-ops until initAppInsights() has actually loaded the
// SDK. Calling track* on an unloaded instance throws.
export function trackException(error: unknown): void {
  if (!isLoaded) return;
  appInsights.trackException({
    exception: error instanceof Error ? error : new Error(String(error)),
  });
}
